import { useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Button, Dialog, Text } from 'components';
import { Field, Form, Formik } from 'formik';
import { AuthContext } from 'hooks/useAuth';
import { useContextSelector } from 'use-context-selector';

import { registerService } from '../../../../../services/register';

export const DialogConfirm = ({ handleCloseDialogConfirm, openDialogConfirm, line }) => {
  const [isLoading, setIsLoading] = useState(false);
  const user = useContextSelector(AuthContext, (context) => context.user);

  const activeOrDesactive = () => {
    if (line && line.active === true) {
      return 'desativar';
    } else {
      return 'ativar';
    }
  };

  const handleUpdateActiveCarrier = async (values) => {
    setIsLoading(true);
    toast.info('Atualizando ativo da transportadora');
    try {
      const { data } = await registerService.updateCarrirerActive({
        active: line.active,
        id: line.id,
        user: user.id,
        obs: values.input_observation,
      });

      toast.success('Ativo da transportadora atualizado com sucesso');
      handleCloseDialogConfirm();
    } catch (error) {
      console.log(error.message);
      toast.error('Erro ao atualizar ativo da transportadora');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Dialog open={openDialogConfirm}>
        <Dialog.Title onClose={handleCloseDialogConfirm}>Confirmação</Dialog.Title>
        <Dialog.Content>
          <Formik initialValues={{ input_observation: '' }} onSubmit={handleUpdateActiveCarrier}>
            {(props) => (
              <Form>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      align='center'
                      variant='h2'
                      style={{ fontSize: '24px', fontWeight: 'bold' }}
                    >
                      Deseja realmente {activeOrDesactive()} esse transportadora ?
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Field
                      size='small'
                      loading={isLoading}
                      name='input_observation'
                      variant='outlined'
                      fullWidth
                      label='Observação'
                      component={Text}
                      multiline
                      minRows={5}
                    />
                  </Grid>
                  <Grid item xs={2} sm={2} md={2} lg={2}></Grid>
                  <Grid item xs={4} sm={4} md={4} lg={4}>
                    <Button
                      color='secondary'
                      fullWidth
                      onClick={handleCloseDialogConfirm}
                      loading={isLoading}
                    >
                      Cancelar
                    </Button>
                  </Grid>
                  <Grid item xs={4} sm={4} md={4} lg={4}>
                    <Button fullWidth type='submit' loading={isLoading}>
                      Atualizar
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Dialog.Content>
      </Dialog>
    </>
  );
};
